var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ApolloQuery", {
        ref: "appolloQuery",
        attrs: { query: _vm.myQuery, variables: _vm.getVariables },
        on: { loading: _vm.isSearching },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ result: { data, error }, query }) {
              return [
                error
                  ? _c("section", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "api-errors alert alert-danger text-center",
                          attrs: { role: "alert" },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.getErrorMessage(error)) +
                              "\n                "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInvalidPageNumber
                  ? _c("section", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "api-errors alert alert-danger text-center",
                          attrs: { role: "alert" },
                        },
                        [
                          _vm._v(
                            "\n                    Error: " +
                              _vm._s(_vm.currentPage) +
                              " is an invalid page number.\n                "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                data && !error && !_vm.isInvalidPageNumber
                  ? _c(
                      "section",
                      {
                        staticClass: "container-fluid",
                        attrs: { id: "main-section" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-6 table-browser-remove-left-padding",
                              },
                              [
                                _c("search", {
                                  attrs: {
                                    "initial-search-text": _vm.userSearchText,
                                  },
                                  on: {
                                    "update-search": _vm.updateSearch,
                                    "reset-pagination": _vm.resetPagination,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-default",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFilterOption()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-filter",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(" Filters\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-default",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleTableSettingModal()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-cog",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(" Settings\n                        "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.searching && data[_vm.operationName].edges
                                ? _c(
                                    "div",
                                    { staticClass: "pull-right text-right" },
                                    [
                                      _c("page-range", {
                                        attrs: {
                                          "page-length": _vm.pageLength,
                                          "current-page": _vm.currentPage,
                                          "total-count":
                                            data[_vm.operationName].totalCount,
                                        },
                                        on: {
                                          isInvalidPageNumber: function (
                                            $event
                                          ) {
                                            _vm.isInvalidPageNumber = true
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _vm.tableSettingModalOpened
                              ? _c("table-setting", {
                                  ref: "table-setting",
                                  attrs: {
                                    "initial-modal-opened":
                                      _vm.tableSettingModalOpened,
                                    "initial-page-length": _vm.pageLength,
                                    "initial-visible-column-options":
                                      _vm.visibleColumnOptions,
                                    "initial-visible-detail-options":
                                      _vm.visibleDetailOptions,
                                    "initial-alternative-name-setting":
                                      _vm.alternativeNameSetting,
                                    "alternative-name-types":
                                      _vm.requiredProps.alternativeNameTypes,
                                    "init-show-federated": _vm.showFederated,
                                  },
                                  on: {
                                    "close-modal": _vm.toggleTableSettingModal,
                                    "apply-settings": _vm.applyTableSettings,
                                    "apply-default-settings":
                                      _vm.applyDefaultSettings,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [
                              _c("input", {
                                ref: "all_in_queryset",
                                staticClass:
                                  "select-all-compatible table-browser-hide-element",
                                attrs: {
                                  type: "checkbox",
                                  name: "all_in_queryset",
                                },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: { type: "hidden", name: "qs" },
                                domProps: {
                                  value: data[_vm.operationName].allQsUuid,
                                },
                              }),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { ref: "tableWrapper", staticClass: "row mt-3" },
                          [
                            _c(
                              "table",
                              {
                                staticClass: "table table-browser-table",
                                style: _vm.tableWidth,
                              },
                              [
                                _c(
                                  "thead",
                                  {
                                    staticClass: "table-browser-sticky-header",
                                  },
                                  [
                                    _c("tr", [
                                      _vm.canViewBulkAction
                                        ? _c(
                                            "th",
                                            {
                                              staticClass:
                                                "table-browser-bulk-action-col-fixed-width",
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-browser-inline-block",
                                                  },
                                                  [
                                                    _c("input", {
                                                      ref: "partial-select",
                                                      attrs: {
                                                        type: "checkbox",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.updatePartialSelect(
                                                            $event.target
                                                              .checked
                                                          )
                                                        },
                                                        keypress: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            !$event.type.indexOf(
                                                              "key"
                                                            ) &&
                                                            $event.keyCode !==
                                                              13
                                                          )
                                                            return null
                                                          $event.preventDefault()
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-browser-inline-block",
                                                  },
                                                  [
                                                    _c("bulk-action", {
                                                      attrs: {
                                                        "bulk-action-options":
                                                          _vm.extraInfo
                                                            .bulkActionOptions,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        [
                                          _vm._v(
                                            "\n                                     Name\n                                     "
                                          ),
                                          _c("sort", {
                                            attrs: {
                                              "header-name": "name",
                                              "initial-order": _vm.order,
                                            },
                                            on: {
                                              "update-sort": _vm.updateSort,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.visibleColumnOptions.shortDefinition
                                        .selected
                                        ? _c("th", [
                                            _vm._v(
                                              "\n                                     Details\n                                 "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.visibleColumnOptions.status.selected
                                        ? _c("th", [
                                            _vm._v(
                                              "\n                                     Status\n                                 "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.visibleColumnOptions.modified.selected
                                        ? _c(
                                            "th",
                                            [
                                              _vm._v(
                                                "\n                                     Last Updated\n                                     "
                                              ),
                                              _c("sort", {
                                                attrs: {
                                                  "header-name": "modified",
                                                  "initial-order": _vm.order,
                                                },
                                                on: {
                                                  "update-sort": _vm.updateSort,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.visibleColumnOptions.created.selected
                                        ? _c(
                                            "th",
                                            [
                                              _vm._v(
                                                "\n                                     Created On\n                                     "
                                              ),
                                              _c("sort", {
                                                attrs: {
                                                  "header-name": "created",
                                                  "initial-order": _vm.order,
                                                },
                                                on: {
                                                  "update-sort": _vm.updateSort,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showActionsDropdown
                                        ? _c("th", [
                                            _vm._v(
                                              "\n                                     Item Actions\n                                 "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.visibleColumnOptions.tag.selected
                                        ? _c("th", [
                                            _vm._v(
                                              "\n                                     Tags\n                                 "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    _c(
                                      "transition",
                                      {
                                        attrs: {
                                          name: "table-browser-filter-option-slide",
                                        },
                                      },
                                      [
                                        _vm.filterOptionsShown
                                          ? _c("tr", [
                                              _vm.canViewBulkAction
                                                ? _c("td", [
                                                    _c(
                                                      "div",
                                                      [
                                                        _c("filter-option", {
                                                          attrs: {
                                                            "initial-multiple-selected-option":
                                                              _vm.multipleSelectedItemControlStatus,
                                                            options:
                                                              _vm.itemControlStatus,
                                                            "total-visible-table-columns":
                                                              _vm.totalVisibleColumnNumber,
                                                          },
                                                          on: {
                                                            "update-selected-option":
                                                              _vm.updateItemControlStatusOption,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm.canFilterByType
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c("filter-option", {
                                                          attrs: {
                                                            "initial-multiple-selected-option":
                                                              _vm.multipleSelectedTypes,
                                                            options:
                                                              _vm.requiredProps
                                                                .typeOptions,
                                                            "total-visible-table-columns":
                                                              _vm.totalVisibleColumnNumber,
                                                          },
                                                          on: {
                                                            "update-selected-option":
                                                              _vm.updateTypeOption,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]),
                                              _vm._v(" "),
                                              _vm.visibleColumnOptions
                                                .shortDefinition.selected
                                                ? _c("td")
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.visibleColumnOptions.status
                                                .selected
                                                ? _c("td", [
                                                    _c(
                                                      "div",
                                                      [
                                                        _c("filter-option", {
                                                          attrs: {
                                                            "initial-multiple-selected-option":
                                                              _vm.multipleSelectedStatus,
                                                            options:
                                                              _vm.requiredProps
                                                                .stateOptions,
                                                            "total-visible-table-columns":
                                                              _vm.totalVisibleColumnNumber,
                                                          },
                                                          on: {
                                                            "update-selected-option":
                                                              _vm.updateStateOption,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.visibleColumnOptions.modified
                                                .selected
                                                ? _c("td")
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.visibleColumnOptions.created
                                                .selected
                                                ? _c("td")
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showActionsDropdown
                                                ? _c("td")
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.visibleColumnOptions.tag
                                                .selected
                                                ? _c("td")
                                                : _vm._e(),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !data[_vm.operationName].totalCount
                                      ? _c(
                                          "tr",
                                          { staticClass: "text-center" },
                                          [
                                            _c(
                                              "td",
                                              {
                                                attrs: {
                                                  colspan:
                                                    _vm.totalVisibleColumnNumber,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                     No results found\n                                 "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hasSelected
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "text-center",
                                              attrs: {
                                                colspan:
                                                  _vm.totalVisibleColumnNumber,
                                              },
                                            },
                                            [
                                              _c("bulk-action-helper-text", {
                                                ref: "bulk-action-helper-text",
                                                attrs: {
                                                  "verbose-operation-name":
                                                    _vm.verboseOperationName,
                                                  "page-length": _vm.pageLength,
                                                  "total-count":
                                                    data[_vm.operationName]
                                                      .totalCount,
                                                  "total-selected-items":
                                                    _vm.totalSelectedItems,
                                                },
                                                on: {
                                                  "select-all-items": function (
                                                    $event
                                                  ) {
                                                    return _vm.selectAll(
                                                      data[_vm.operationName]
                                                        .totalCount
                                                    )
                                                  },
                                                  "clear-selections":
                                                    _vm.clearSelections,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.searching && data[_vm.operationName]
                                      ? _vm._l(
                                          data[_vm.operationName].edges,
                                          function (item) {
                                            return _c("tr", { key: item.id }, [
                                              _vm.canViewBulkAction
                                                ? _c("td", [
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table-browser-inline-block",
                                                        },
                                                        [
                                                          _c("input", {
                                                            ref: "item-checkboxes",
                                                            refInFor: true,
                                                            staticClass:
                                                              "v-select-all-compatible",
                                                            attrs: {
                                                              type: "checkbox",
                                                              name: "items",
                                                              id: _vm.getCustomId(
                                                                item.node
                                                                  .aristotleId
                                                              ),
                                                            },
                                                            domProps: {
                                                              value:
                                                                item.node
                                                                  .aristotleId,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.updateSingleSelect(
                                                                  $event.target
                                                                    .checked,
                                                                  data[
                                                                    _vm
                                                                      .operationName
                                                                  ].edges.length
                                                                )
                                                              },
                                                              keypress:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    !$event.type.indexOf(
                                                                      "key"
                                                                    ) &&
                                                                    $event.keyCode !==
                                                                      13
                                                                  )
                                                                    return null
                                                                  $event.preventDefault()
                                                                },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table-browser-inline-block",
                                                        },
                                                        [
                                                          item.node
                                                            .favouriteInfo
                                                            ? _c(
                                                                "toggle-favourite",
                                                                {
                                                                  attrs: {
                                                                    "item-uuid":
                                                                      item.node
                                                                        .uuid,
                                                                    "initial-favourite-info":
                                                                      item.node
                                                                        .favouriteInfo,
                                                                    "base-end-point":
                                                                      _vm
                                                                        .extraInfo
                                                                        .favouriteBaseEndPoint,
                                                                  },
                                                                  on: {
                                                                    "update-favourite-info":
                                                                      _vm.updateFavoriteInfo,
                                                                  },
                                                                }
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table-browser-inline-block",
                                                        },
                                                        [
                                                          item.node.statuses
                                                            .length
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "fa fa-university fa-fw",
                                                                attrs: {
                                                                  title:
                                                                    "Registered",
                                                                },
                                                              })
                                                            : _c("i", {
                                                                staticClass:
                                                                  "fa fa-flag-o fa-fw",
                                                                attrs: {
                                                                  title:
                                                                    "In progress",
                                                                },
                                                              }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table-browser-inline-block",
                                                        },
                                                        [
                                                          item.node.isFederated
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "fa fa-chart-network fa-fw",
                                                                attrs: {
                                                                  title:
                                                                    "Federated",
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  _c("metadata-name", {
                                                    attrs: {
                                                      item: item.node,
                                                      "alternative-name-setting":
                                                        _vm.alternativeNameSetting,
                                                      "is-shared-sandbox-view":
                                                        _vm.isSharedSandboxView,
                                                      "shared-item-end-point":
                                                        _vm.extraInfo
                                                          .sharedItemEndPoint,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.visibleColumnOptions
                                                .shortDefinition.selected
                                                ? _c(
                                                    "td",
                                                    [
                                                      _c("metadata-detail", {
                                                        attrs: {
                                                          "query-operation":
                                                            _vm.operationName,
                                                          item: item.node,
                                                          "visible-detail-option":
                                                            _vm.visibleDetailOptions,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.visibleColumnOptions.status
                                                .selected
                                                ? _c(
                                                    "td",
                                                    [
                                                      _c("metadata-status", {
                                                        attrs: {
                                                          statuses:
                                                            item.node.statuses,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.visibleColumnOptions.modified
                                                .selected
                                                ? _c("td", [
                                                    _vm._v(
                                                      "\n                                         " +
                                                        _vm._s(
                                                          _vm.getPrettyDateTime(
                                                            item.node.modified
                                                          )
                                                        ) +
                                                        "\n                                     "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.visibleColumnOptions.created
                                                .selected
                                                ? _c("td", [
                                                    _vm._v(
                                                      "\n                                         " +
                                                        _vm._s(
                                                          _vm.getPrettyDateTime(
                                                            item.node.created
                                                          )
                                                        ) +
                                                        "\n                                     "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showActionsDropdown
                                                ? _c(
                                                    "td",
                                                    [
                                                      _c("item-action", {
                                                        attrs: {
                                                          item: item.node,
                                                          "extra-info":
                                                            _vm.extraInfo,
                                                          "is-delete-view":
                                                            _vm.isDeleteView,
                                                        },
                                                        on: {
                                                          "removed-from-workgroup":
                                                            function ($event) {
                                                              return query.refetch()
                                                            },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.visibleColumnOptions.tag
                                                .selected
                                                ? _c(
                                                    "td",
                                                    [
                                                      _c("metadata-tag", {
                                                        attrs: {
                                                          "tag-info":
                                                            item.node.tagInfo,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ])
                                          }
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        data && _vm.searching
                          ? _c("div", { staticClass: "text-center" }, [
                              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                              _vm._v(" Loading...\n                "),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row mt-3" },
                          [
                            _vm.canViewBulkAction
                              ? _c("bulk-action", {
                                  attrs: {
                                    "bulk-action-options":
                                      _vm.extraInfo.bulkActionOptions,
                                    reversed: true,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.searching &&
                        data[_vm.operationName] &&
                        !_vm.isInvalidPageNumber
                          ? _c("pagination", {
                              ref: "pagination",
                              attrs: {
                                "total-page": data[_vm.operationName].pageCount,
                                align: "center",
                                "boundary-links": "",
                              },
                              on: {
                                change: (pageIndex) =>
                                  _vm.changePage(pageIndex),
                              },
                              model: {
                                value: _vm.currentPage,
                                callback: function ($$v) {
                                  _vm.currentPage = $$v
                                },
                                expression: "currentPage",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !data
                  ? _c("section", { attrs: { id: "loading-section" } }, [
                      _c("div", { staticClass: "text-center" }, [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading...\n                "),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }